<template>
  <section class="evaluation">
    <div class="evaluation-title">
      整体评价
    </div>
    <div class="evaluation-show">
      <van-rate
        v-model="totalStar"
        :size="36"
        color="#ff4555"
        void-icon="star"
        void-color="#d8d8d8"
        @change="rateChangeTotal"
      />
    </div>
    <div class="evaluation-area">
      <ul>
        <li class="evaluation-list">
          <div class="evaluation-content">
            服务态度
          </div>
          <div class="evaluation-select">
            <van-rate
              v-model="attitudeStar"
              :size="21"
              color="#ff4555"
              void-icon="star"
              void-color="#d8d8d8"
              @change="rateChangeAttitude"
            />
          </div>
        </li>
        <li class="evaluation-list">
          <div class="evaluation-content">
            服务速度
          </div>
          <div class="evaluation-select">
            <van-rate
              v-model="speedStar"
              :size="21"
              color="#ff4555"
              void-icon="star"
              void-color="#d8d8d8"
              @change="rateChangeSpeed"
            />
          </div>
        </li>
        <li class="evaluation-list">
          <div class="evaluation-content">
            作品满意度
          </div>
          <div class="evaluation-select">
            <van-rate
              v-model="satisfiedStar"
              :size="21"
              color="#ff4555"
              void-icon="star"
              void-color="#d8d8d8"
              @change="rateChangeSatisfied"
            />
          </div>
        </li>
      </ul>
    </div>
    <div class="evaluation-text">
      <textarea v-model="comment" placeholder="满足你的期待吗？说说服务中需要改进的地方，帮助我们做的更好吧。"></textarea>
    </div>
    <div class="evaluation-action">
      <div class="evaluation-tips" v-if="alterNumber > 0">
        <span>您当前还有修改次数，提交后不可使用</span>
      </div>

      <button type="button" class="evaluation-commit" @click="save" v-cbs="'评价页-提交'">提交</button>
    </div>
  </section>
</template>

<script>
import { trackElClickH5 } from '@changba/funny';

export default {
  name: 'Evaluation',

  props: {
    id: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      totalStar: 0,
      attitudeStar: 0,
      speedStar: 0,
      satisfiedStar: 0,
      comment: '',
      alterNumber: 0
    }
  },

  created() {
    this.refresh();
  },

  methods: {
    async refresh() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicService/musicmall/getOrderRemainNum', {
        data: {
          orderid: this.id
        }
      });

      this.$toast.clear();

      if (code === 1) {
        this.alterNumber = data;
      }
    },

    async save() {
      if (this.totalStar < 1) {
        this.$toast.fail('请选择整体评价');
        return;
      }

      if (this.comment) {
        trackElClickH5('备注-输入');
      }

      this.$toast.loading();

      const { code, msg } = await this.$fetch('/api/musicService/musicmall/evaluationOrder', {
        method: 'post',
        data: {
          orderid: this.id,
          comment: this.comment,
          total: this.totalStar,
          attitude: this.attitudeStar,
          speed: this.speedStar,
          approving: this.satisfiedStar
        }
      });

      this.$toast.clear();

      if (code === 1) {
        this.$toast.success('提交成功');
        this.$router.push(`/order/${this.id}`);
      }
      else {
        this.$toast.fail(msg);
      }
    },

    rateChangeTotal(star) {
      trackElClickH5('整体评价', { star });
    },

    rateChangeAttitude(star) {
      trackElClickH5('服务态度', { star });
    },

    rateChangeSpeed(star) {
      trackElClickH5('服务速度', { star });
    },

    rateChangeSatisfied(star) {
      trackElClickH5('作品满意度', { star });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@cdn_js/styles/evaluation.scss";
</style>
